import React from 'react';
import { formatStoredDateValue, toHtmlDateValue } from '../utils/specDateValue';

/**
 * 사양 날짜 입력 — 클릭 시 브라우저 캘린더( type="date" )로 선택.
 */
const SpecDateInput = ({
    value,
    onChange,
    disabled = false,
    className = 'field-input spec-date-input',
    title = '',
}) => {
    const htmlValue = toHtmlDateValue(value);

    return (
        <input
            type="date"
            className={className}
            value={htmlValue}
            onChange={(e) => onChange(formatStoredDateValue(e.target.value))}
            disabled={disabled}
            title={title || '날짜 선택'}
        />
    );
};

export default SpecDateInput;
